<template>
    <div class="stacked-area-chart">
        <ECharts :option="getOptions()" class="echart-graph" />
    </div>
</template>
<script>
import Vue from "vue";
import { createComponent, plugin } from "echarts-for-vue";
import * as echarts from "echarts/lib/echarts";
import "echarts/lib/chart/heatmap";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/grid";
import "echarts/lib/component/visualMap";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import { LineChart } from "echarts/charts";

echarts.use([LineChart]);

Vue.use(plugin, { echarts });
//https://echarts.apache.org/examples/en/editor.html?c=area-stack-gradient
export default Vue.extend({
    name: "StackedAreaChart",
    components: {
        ECharts: createComponent({ echarts }),
    },
    props: {
        title: {
            type: String,
            default: "Gradient Stacked Area Chart",
        },

        legends: {
            type: Array,
            default: () => [],
        },
        xAxisData: {
            type: Array,
            default: () => [],
        },
        series: {
            type: Array,
            default: () => [],
        },
        colors: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        getOptions() {
            return {
                // color: ["#80FFA5", "#00DDFF", "#37A2FF", "#FF0087", "#FFBF00"],
                color: this.colors,
                title: {
                    text: this.title,
                    left: "center",
                    bottom: 20,
                    top: 20,
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        label: {
                            backgroundColor: "#6a7985",
                        },
                    },
                },
                legend: {
                    data: this.legends || [],
                },
                toolbox: {
                    feature: {
                        saveAsImage: {},
                    },
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: "category",
                        boundaryGap: false,
                        data: this.xAxisData,
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                    },
                ],
                series: this.series,
            };
        },
    },
});
</script>

<style scoped lang="scss">
.stacked-area-chart {
    width: 100%;
    height: 300px;

    .echart-graph {
        width: 100%;
        height: 100%;
    }
}
</style>
